import ShareableLinkNdaRejected from './ShareableLinkNdaRejected.component';

export default ShareableLinkNdaRejected;